document.addEventListener('DOMContentLoaded', function() {
    function checkNostoList() {
        var nostoList = document.querySelector('.nosto-list');
        var ccart = document.querySelector(".js-drawer-open-cart");
      
        if (!nostoList) {
            setTimeout(checkNostoList, 100);
            return;
        }

        // Check if there is a bundle product
        var bundleOptionsSelector = document.getElementById('bundle-options-selector');
        if (!bundleOptionsSelector) {
            return; // Exit if there's no bundle product
        }

        // Cache DOM elements
        const addToCartBtn = document.getElementById('add-to-cart-bundle-btn');
        let variantId;

        // Function to add bundle item to cart
        function bundleAddToCart(quantity, variantId) {
            let data = {
                'items': [{
                    'id': variantId,
                    'quantity': quantity
                }]
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(response => {
                document.dispatchEvent(new Event('cart:build'));
                ccart.click();
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }

        addToCartBtn.addEventListener('click', function() {
            variantId = bundleOptionsSelector.value;
            bundleAddToCart(1, variantId); 
        });
    }

    checkNostoList();
});